import { React } from 'react';
import ReactGA from 'react-ga';

const LimitedMain = () => (
    <div className="game-container top">
        <div className="le-container">
            <img src="./img/glamshots/LE.png" alt="" />
        </div>
        <div className="product-container">
            <div className="glamshot-container">
                <img src="./img/glamshots/NISClassic1_StoreLE_Glamshot_NSW_USA_1.jpg" alt="Limited Edition Glamshot" />
            </div>
            <div className="product-links">
                <h1 className="product-tag">
                Purchase Now!
                </h1>
                <div className="product-buttons">
                    <a href="https://store.nisamerica.com/prinny-presents-nis-classics-volume-1-phantom-brave-soul-nomad"target="_blank" rel="noreferrer"
                                onClick={
                                    ()=>{
                                        ReactGA.event({
                                            category: 'engagement',
                                            action: 'generate_lead',
                                            label: 'NISA / Preorder Prinny Presents Vol 1: Phantom Brave / Soul Nomad / SE / NISA Online Store'
                                          })
                                    }
                                }
                            >
                    <button className="store-link">
                        NISA Online Store
                    </button>
                    </a>
                    <a href="https://store.nisaeurope.com/collections/prinny-presents-nis-classics-volume-1" target="_blank" rel="noreferrer"
                                onClick={
                                    ()=>{
                                        ReactGA.event({
                                            category: 'engagement',
                                            action: 'generate_lead',
                                            label: 'NISA / Preorder Prinny Presents Vol 1: Phantom Brave / Soul Nomad / SE / NISA EU'
                                          })
                                    }
                                }
                            >
                    <button className="store-link">
                        NISA EU  Online Store
                    </button>
                    </a>
                </div>
            </div>
        </div>
    </div>
)

export default LimitedMain;